// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"SR-z","sponsoredTooltipWrapper":"TR-z","sponsoredTooltip":"UR-z","newCard":"VR-z"};